
import {Component, Prop, Watch, Vue} from "vue-property-decorator";
import TelefonNumarasi from "@/components/inputs/TelefonNumarasi.vue";
import {UlkeEntity} from "@/entity/UlkeEntity";
import {IletisimBilgisiTuru} from "@/enum/IletisimBilgisiTuru";

@Component({
  components: {TelefonNumarasi}
})
export default class UlkeTelefon extends Vue {
  @Prop({ default: () => ({ ulke_id: "", deger: "" }) }) value!: { ulke_id: string, deger: string };
  @Prop() iletisimTurId !: number;
  @Prop() required!: boolean | string;

  ulkeler: Array<UlkeEntity> = [];
  phone: string = "";
  prefix: string|null = "";
  ulkeSecildi: boolean = false;

  autocompleteText(event: KeyboardEvent) {
    if (this.ulkeSecildi) {
      event.preventDefault();
    }
  }

  get label() {
    if (this.iletisimTurId === IletisimBilgisiTuru.telMobil) {
      return "Mobil Telefon"
    } else if (this.iletisimTurId === IletisimBilgisiTuru.telSabit) {
      return "Sabit Telefon"
    } else if (this.iletisimTurId === IletisimBilgisiTuru.faks) {
      return "Faks"
    }
  }

  get isRequired() {
    return this.required || this.required == "";
  }

  mounted() {
    this.onValueChange();
    this.load();
  }

  @Watch("value", { immediate: true, deep: true })
  onValueChange() {
    console.log('CHANGE', this.value.ulke_id);
    this.prefix = this.value.ulke_id || "";
    this.phone = this.value.deger || "";
  }

  input() {
    this.ulkeSecildi = !!this.prefix;
    this.$emit("input", {
      ulke_id: this.prefix || "",
      deger: this.phone || ""
    });
  }

  load() {
    this.$helper.requestWithCache("/api/v1/ulke").then(response => {
      this.ulkeler = response.data;
      // this.prefix = null;
    });
  }
}
